// import queryString from "query-string";
import React, { useContext } from "react";
import { CustomButton2, CustomDropdownFilter } from "../../../../components";
import "./index.scss";
import values from "../../../../values";
import Context from "../../../../context";
import { IItem } from "../../../../types/common.interface";

const Filter = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);

  const { requestDriver, setRequestDriver } = useContext(Context.DriverScreen);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        <>
          {/* <p className="filter-labels">استان:</p>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder="انتخاب استان"
              isLoading={getAllProvince.isLoading}
            />
            <p className="filter-labels">شهر:</p>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestDriver?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestDriver!({
                  ...requestDriver,
                  filters: {
                    ...requestDriver?.filters,

                    city: event,
                  },
                })
              }
              placeHolder="انتخاب شهر"
              isLoading={getAllCity.isLoading}
            /> */}
        </>
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestDriver!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default Filter;
